export default __webpack_public_path__ + "static/media/CC_PrimaryLogo_Colour.837e7593.png";